import React from "react";
import { MdPermScanWifi } from "react-icons/md";
import './NotConnectedInternet.css';
import useTranslation from "../../../hooks/use-translation";
const NotConnectedInternet = (props) => {
    const { translate } = useTranslation();
    return (React.createElement("div", { style: { padding: "0 10px" } },
        React.createElement("div", { className: "d-flex w-100 p-4 not-connected_internet__container gap-6 justify-content-start align-items-center mt-3 mb-3" },
            React.createElement("div", { className: '' },
                React.createElement("div", { className: 'rounded-circle d-flex justify-content-center align-items-center not-connected_internet__icon-box' },
                    React.createElement(MdPermScanWifi, null))),
            React.createElement("div", { className: 'not-connected_internet__text-box' },
                React.createElement("h1", { className: 'mb-1' }, translate("internet_not_connected_title")),
                React.createElement("p", null, translate("internet_not_connected_description"))))));
};
export default NotConnectedInternet;
